































































































































































import {
  defineComponent,
  ref,
  onMounted,
  onUpdated,
  useContext,
  useRouter,
  useRoute,
  useFetch,
} from '@nuxtjs/composition-api';
import {
  SfHeading,
  SfNotification,
} from '@storefront-ui/vue';
import SfBreadcrumbs from "~/components/Sf/SfBreadcrumbs.vue";
import { useContent, useContact, useGtm } from '~/composables';
import { getMetaInfo } from '~/helpers/getMetaInfo';
import { Breadcrumb } from '~/modules/catalog/types';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required, email, max } from 'vee-validate/dist/rules';
import PageBuilder from '~/components/PageBuilder/PageBuilder.vue';
import { CmsBlock } from '~/modules/GraphQL/types';
import VueScrollTo from 'vue-scrollto';
import { usePageStore } from '~/stores/page';
import { assign, join, map, trimEnd, isEmpty, clone, has } from 'lodash-es';
import Utils from '~/helpers/utils';
import Vue from "vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

Vue.component("VSelect", vSelect);

export default defineComponent({
  name: 'ContactUs',
  components: {
    SfHeading,
    SfBreadcrumbs,
    SfNotification,
    PageBuilder,
    ValidationObserver,
    ValidationProvider
  },
  setup() {
     const { preventXSSAttacks, preventSqlAttacks } = Utils();
    const pageStore = usePageStore();
    const { eventPageLoad, eventFormSubmit, eventCustomlinksInteracted } = useGtm();
    const { loadBlocks } = useContent();
    const route = useRoute();
    const blocks = ref<CmsBlock[]>([]);
    const { localePath, app: { i18n, $recaptcha, $config } } = useContext();
    const pageMetaData = ref({
      meta_title: join([i18n.t('Contact Us'), $config.defaultMetaTitle], ' | '),
      meta_description: i18n.t('Contact Us'),
      meta_keyword: i18n.t('Contact Us'),
      pageTitle: i18n.t('Contact Us'),
      metaDescription: i18n.t('Contact Us'),
      pageUrl: trimEnd($config.baseUrl, '/') + route.value.path,
    });
    const isRecaptchaEnabled = ref<boolean>(typeof $recaptcha !== 'undefined' && Boolean($config.isRecaptcha));
    const breadcrumbs = ref<Breadcrumb[]>([]);
    const isOpenNotification = ref(false);
    const notification = ref({
      message: '',
      type: "secondary"
    });
    const recaptchaError = ref('');
    const getInitialForm = () => ({
      name: '',
      position: '',
      telephone: '',
      email: '',
      company: '',
      comment: '',
      industry_ids: [],
    });
    const form = ref(getInitialForm());
    const contactForm = ref(null);
    extend('required', {
      ...required,
      message: 'The {_field_} is required',
    });
    extend('email', {
      ...email,
      message: 'Please enter a correct e-mail address',
    });
    extend('max', {
      ...max,
      params: ['length'],
      message: 'The {_field_} cannot exceed {length} characters',
    });


    // Add custom validation rule to check phone or telephone number
    const phoneOrTelephoneRule = {
      message() {
        return `Please enter a valid telephone number`;
      },
      validate(value) {
        // Custom regex for a phone number
        const phonePattern = /^((1[3456789][0-9])+\d{8})$/;
        const telPattern = /^(0\d{2,3}-\d{7,8})$/;

        // Check for either of these to return true
        if (phonePattern.test(value)) {
          return true;
        } else {
          if (telPattern.test(value)) {
            return true;
          }
        }
        return false;
      }
    };
    const sqlAttacksRule  = {
     message() {
        return `Please enter a valid data`;
      },
      validate(value) {
        return !preventSqlAttacks(value);
      }
    };
    extend('phoneOrTelephone', phoneOrTelephoneRule);
    extend('sqlAttacks', sqlAttacksRule);

    const scrollToTop = () => {
      const options = {
        container: 'body',
        lazy: false,
        offset: 0,
        force: true,
      };
      VueScrollTo.scrollTo('body', 500, options);
    };
    const showMessage = (message, type) => {
      notification.value = {
        message: message as string,
        type: type
      };
      isOpenNotification.value = true;
      scrollToTop();
    };

    const router = useRouter();
    const { submitComment, getContactIndustry } = useContact();
    const onSubmit = async () => {
      let submitData = assign(clone(form.value), {
        industry_ids: map(form.value.industry_ids, (item) => item.id)
      });
      if (isRecaptchaEnabled.value) {
        try {
          $recaptcha.init();
          const recaptchaToken = await $recaptcha.getResponse();
          submitData = assign(submitData, { recaptchaToken });
          const subject = has(route.value.query, 'subject')?route.value.query.subject:'';
          submitData = assign(submitData, { subject });
        } catch (err) {
          recaptchaError.value = i18n.t('Validation failed') as string;
          eventFormSubmit({
            formName: "Contact Us",
            formAction: "Form Submitted",
            formStatus: "Form Error",
            formErrorMessages: i18n.t('Validation failed')
          });
          return;
        }
      }
      const result = await submitComment(submitData);
      if (result.errors) {
        showMessage(result.errors[0]?.message as string, "danger");
        eventFormSubmit({
          formName: "Contact Us",
          formAction: "Form Submitted",
          formStatus: "Form Error",
          formErrorMessages: result.errors[0]?.message
        });
      } else {
        if (result.data && result.data['contactUs']['status']) {
          form.value = getInitialForm();
          contactForm.value.reset();
          leftCharacters.value = maxCharacters.value;
          eventFormSubmit({
            formName: "Contact Us",
            formAction: "Form Submitted",
            formStatus: "Form Success",
          });
          router.push(localePath('/success'));
        } else {
          showMessage(i18n.t('Failed to submit') as string, "danger");
          eventFormSubmit({
            formName: "Contact Us",
            formAction: "Form Submitted",
            formStatus: "Form Error",
            formErrorMessages: i18n.t('Failed to submit')
          });
        }
      }
      if (isRecaptchaEnabled.value) {
        $recaptcha.reset();
      }
    };

    onUpdated(() => {
      document.body.classList.remove('show-hero-img');
    });
    onMounted(async () => {
      document.body.classList.remove('show-hero-img');
      breadcrumbs.value = [
        {
          text: i18n.t('Home') as string,
          link: localePath('/'),
        },
        {
          text: i18n.t('Contact Us') as string,
          link: '',
        }
      ];
      pageStore.$patch((state) => {
        state.pageData = assign(state.pageData, {
          pageName: i18n.t('Contact Us'),
          pageTitle: i18n.t('Contact Us'),
          pageCategory: join(map(breadcrumbs.value, (item) => item.text), '/'),
          breadCrumbs: map(breadcrumbs.value, (item) => item.text),
        });
      });
      eventPageLoad();
    });
    const resetForm = () => {
      form.value = getInitialForm();
      leftCharacters.value = maxCharacters.value;
      recaptchaToken.value = '';
      if (isRecaptchaEnabled.value) {
        $recaptcha.reset();
      }
      eventCustomlinksInteracted({
        "eventlabel": 'Reset Form',
        "eventCategory": "Contact Us",
      });
    };
    const onRecaptchaExpired = () => {
      recaptchaError.value = i18n.t('Verification code expired') as string;
      recaptchaToken.value = '';
    };
    const onRecaptchaSuccess = (token) => {
      recaptchaToken.value = token;
      recaptchaError.value = '';
    };
    const telCheck = () => {
      const telephone = form.value.telephone;
      form.value.telephone = telephone.replace(/(?:(?!(\d|-))[\s\S])*/g, '');
    };
    const maxCharacters = ref(500);
    const leftCharacters = ref(maxCharacters.value);
    const checkMaxCharacters = () => {
      if (maxCharacters.value > form.value.comment.length) {
        leftCharacters.value = maxCharacters.value - form.value.comment.length;
      } else {
        leftCharacters.value = 0;
      }
    };
    const filterCharacters = (e) => form.value[e.target.name] = preventXSSAttacks(e.target.value);
    const recaptchaToken = ref('');
    const industryOptions = ref([]);

    useFetch(async () => {
      const blockIds = ['contact_us_info'];
      blocks.value = await loadBlocks({
        identifiers: blockIds,
        customQuery: {
          cmsBlocks: 'cmsBlock'
        }
      });
      const data = await getContactIndustry();
      if (!isEmpty(data['getContactIndustry']['data'])) {
        industryOptions.value = map(data['getContactIndustry']['data'], (item) => {
          return {
            id: item.industry_id,
            label: item.name,
          };
        });
      }
    });

    return {
      industryOptions,
      blocks,
      pageMetaData,
      recaptchaToken,
      filterCharacters,
      leftCharacters,
      checkMaxCharacters,
      telCheck,
      recaptchaError,
      contactForm,
      isRecaptchaEnabled,
      breadcrumbs,
      isOpenNotification,
      notification,
      form,
      onSubmit,
      resetForm,
      onRecaptchaExpired,
      onRecaptchaSuccess,
      eventCustomlinksInteracted,
    };
  },
  head() {
    return getMetaInfo(this.pageMetaData);
  },
});
